// extracted by mini-css-extract-plugin
export var downArrow = "_g9-0";
export var infoTooltipIcon = "_g9-3";
export var label = "_g9-1";
export var optionCard = "_g9-4";
export var upArrow = "_g9-2";